import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

/** URL pública de una foto guardada en `/uploads/novedades/` */
export const novedadFotoPublicUrl = (archivo) => {
  if (!archivo || typeof archivo !== "string") return null;
  const base = (API_URL || "").replace(/\/$/, "");
  return `${base}/uploads/novedades/${encodeURIComponent(archivo)}`;
};

export const NovedadesApi = {
  getAll: async () => {
    const token = localStorage.getItem("token");
    const res = await axios.get(`${API_URL}/api/novedades`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  getNuevas: async () => {
    const token = localStorage.getItem("token");
    const res = await axios.get(`${API_URL}/api/novedades/nuevas`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  marcarVista: async (id) => {
    const token = localStorage.getItem("token");
    await axios.post(
      `${API_URL}/api/novedades/${id}/vista`,
      {},
      { headers: { Authorization: `Bearer ${token}` } },
    );
  },

  insertar: async (novedad) => {
    const token = localStorage.getItem("token");
    const res = await axios.post(`${API_URL}/api/novedades`, novedad, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  update: async (id, novedad) => {
    const token = localStorage.getItem("token");
    const res = await axios.put(`${API_URL}/api/novedades/${id}`, novedad, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  delete: async (id) => {
    const token = localStorage.getItem("token");
    await axios.delete(`${API_URL}/api/novedades/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  uploadFotos: async (novedadId, files) => {
    const token = localStorage.getItem("token");
    const list = Array.from(files || []).filter(Boolean);
    if (list.length === 0) return { uploaded: [] };

    const formData = new FormData();
    list.forEach((file) => formData.append("files", file));

    const res = await axios.post(
      `${API_URL}/api/novedades/${novedadId}/fotos`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return res.data;
  },

  deleteFoto: async (novedadId, fotoId) => {
    const token = localStorage.getItem("token");
    await axios.delete(
      `${API_URL}/api/novedades/${novedadId}/fotos/${fotoId}`,
      { headers: { Authorization: `Bearer ${token}` } },
    );
  },
};
